/** Repeat — radial copies around the canvas centre (kaleidoscope). */
import type { AffectModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import type { Point, Shape } from '../../core/scene';
import { cloneShape } from '../../core/scene';
import { transformPath } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="2"/><path d="M12 4v3"/><path d="M12 17v3"/><path d="M4 12h3"/><path d="M17 12h3"/><path d="m6.3 6.3 2.1 2.1"/><path d="m15.6 15.6 2.1 2.1"/></svg>';

export function createRepeat(): AffectModule {
  return {
    manifest: {
      id: 'repeat',
      kind: 'affect',
      name: 'Repeat',
      apiVersion: 1,
      description: 'Echo your mark in radial copies around the canvas centre.',
      icon: ICON,
      params: [{ kind: 'slider', key: 'count', label: 'Copies', min: 1, max: 16, step: 1, default: 6 }],
    },

    affect(shapes, ctx) {
      const count = Math.max(1, Math.round(cfgNum(ctx.config, 'count', 6)));
      if (count <= 1) return shapes.slice();
      const cx = ctx.viewport.width / 2;
      const cy = ctx.viewport.height / 2;
      const out: Shape[] = [];
      for (let k = 0; k < count; k++) {
        const ang = (k / count) * Math.PI * 2;
        const cos = Math.cos(ang);
        const sin = Math.sin(ang);
        const rot = (p: Point): Point => {
          const dx = p.x - cx;
          const dy = p.y - cy;
          return { x: cx + dx * cos - dy * sin, y: cy + dx * sin + dy * cos };
        };
        for (const s of shapes) {
          const c = cloneShape(s);
          c.path = transformPath(s.path, rot);
          out.push(c);
        }
      }
      return out;
    },
  };
}
